import { Box, Stack } from "@mui/material";
import { PropTypes } from "prop-types";
import NetworkWifiIcon from "@mui/icons-material/NetworkWifi";
import Battery30Icon from "@mui/icons-material/Battery30";
import parse from "html-react-parser";
import Frame from "react-frame-component";

Phone.propTypes = {
  text: PropTypes.string,
  sms: PropTypes.bool
};

export default function Phone({ text, sms }) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 360,
        borderRadius: 24,
        backgroundColor: "#eee",
        padding: "56px 8px",
        marginTop: 1
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid black",
          height: 480
        }}
      >
        {sms ? (
          <div>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              bgcolor="#efefef"
            >
              <small>
                <NetworkWifiIcon fontSize="small" />
              </small>
              <small>12:30PM</small>
              <Stack direction="row" alignItems="center">
                <small>30%</small>
                <Battery30Icon />
              </Stack>
            </Stack>
            <small>Text Message</small>
            <br />
            <small>Today12:24PM</small>
            <Box
              sx={{
                textAlign: "left",
                color: "black",
                backgroundColor: "#ccc",
                width: "80%",
                borderRadius: 1,
                p: 1,
                ml: 1,
                mt: 2
              }}
            >
              <p>{text}</p>
            </Box>
          </div>
        ) : (
          <Frame width="100%" style={{ minHeight: "100%" }}>
            {parse(text)}
          </Frame>
        )}
      </div>
    </div>
  );
}
